var toUnsigned = function(value) {
  return value >>> 0;
};

module.exports = {
  toUnsigned: toUnsigned
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/mux.js/lib/utils/bin.js
 ** module id = 957
 ** module chunks = 0
 **/